// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createAsyncAction } from 'typesafe-actions';

export interface SendVisitedLabRequestPayload {
  id: number; // lab id
}

export type SendVisitedLabSuccessPayload = {}

export interface SendVisitedLabFailPayload {
  error: Error;
}

const sendVisitedLabActions = createAsyncAction(
  'elearning/SEND_VISITED_LAB_REQUEST',
  'elearning/SEND_VISITED_LAB_SUCCESS',
  'elearning/SEND_VISITED_LAB_FAIL'
)<SendVisitedLabRequestPayload, SendVisitedLabSuccessPayload, SendVisitedLabFailPayload>();

export { sendVisitedLabActions as default};
